export const blockchainValueToNumber = (value: unknown): number => {
  if (typeof value === 'number') return value
  if (typeof value !== 'string') return 0
  const parsed = Number.parseInt(value, value.startsWith('0x') ? 16 : 10)
  return Number.isNaN(parsed) ? 0 : parsed
}
